import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "../../../Employee/EmployeeLayout/Pages/Header";
import Footer from "../../../Employee/EmployeeLayout/Pages/Footer";
import Cookies from "js-cookie";

const AdminLayout = () => {
	const [sidebarPinned, setSidebarPinned] = useState(
		Cookies.get("sidebarPinned") === "true",
	);
	const [sidebarHovered, setSidebarHovered] = useState(false);

	//  EXACT behavior you want
	const sidebarWidth = sidebarPinned || sidebarHovered ? "250px" : "70px";

	return (
		<div
			className="min-h-screen bg-gray-100"
			style={{ "--sidebar-width": sidebarWidth }}
		>
			<Sidebar
				isPinned={sidebarPinned}
				setIsPinned={setSidebarPinned}
				onHoverChange={setSidebarHovered}
			/>
			{/* MAIN AREA */}
			<div className="flex flex-col min-h-screen transition-all duration-300 ml-[var(--sidebar-width)]">
				<Header />

				<main className="flex-1">
					<Outlet />
				</main>

				<Footer />
			</div>
		</div>
	);
};

export default AdminLayout;
